// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1cc5J","sectionsWrapper":"style_sectionsWrapper__1ZuoK"};